// 공개 본문과 CMS 조회의 단일 색상 제목에서 무색 문장부호를 보정한다.
import { normalizeHeadingColors } from "./heading-color.js";
import { normalizeHeadingButtons } from "./heading-button.js";

function formatContent(root) {
  root.querySelectorAll(".board_con_txt, .cms-post-body").forEach(body => {
    normalizeHeadingColors(body);
    normalizeHeadingButtons(body);
  });
}
document.addEventListener("DOMContentLoaded", () => formatContent(document));
document.addEventListener("htmx:afterSwap", event => {
  const root = event.detail.target;
  if (root.matches(".board_con_txt, .cms-post-body")) {
    normalizeHeadingColors(root);
    normalizeHeadingButtons(root);
  }
  formatContent(root);
});
